// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/leaflet/ruler.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/leaflet/ruler-hover.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-control.info-box {
  margin-bottom: 60x;
  padding: 8px 16px;
  font-family: noto-sans-display, aktiv-grotesk, sans-serif;
  font-weight: 300;
  font-size: 1rem;
  background: white;
  border: 1px solid hsl(0, 0%, 90%);
  border-radius: 4px;
  color: #031016;
  max-width: 235px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.leaflet-control.info-box h5 {
  margin: 5px 0 5px;
  color: #031016;
}

.leaflet-control.info-box ul {
  padding-left: 16px;
  margin-top: 4px;
}

.leaflet-popup-content {
  font-family: noto-sans-display, aktiv-grotesk, sans-serif;
  margin: 0;
  width: 325px;
}

.leaflet-popup-content h4 {
  margin: 0 0 5px;
  color: #031016;
}

.leaflet-popup-content-wrapper {
  text-align: left;
  border-radius: 8px;
  padding: 0;
}

.leaflet-container a.leaflet-popup-close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 16px 24px 0 0;
  border: none;
  text-align: center;
  width: 18px;
  height: 14px;
  font-family: noto-sans-display, aktiv-grotesk, sans-serif;
  font-size: 1.4rem;
  color: #c3c3c3;
  text-decoration: none;
  font-weight: 300;
  background: transparent;
}

.leaflet-pane {
  z-index: 4;
}

.leaflet-tile-pane {
  z-index: 2;
}

.leaflet-overlay-pane {
  z-index: 4;
}

.leaflet-shadow-pane {
  z-index: 5;
}

.leaflet-marker-pane {
  z-index: 6;
}

.leaflet-popup-pane {
  z-index: 7;
}

.leaflet-tooltip-pane {
  z-index: 8;
}

.leaflet-map-pane canvas {
  z-index: 1;
}

.leaflet-map-pane svg {
  z-index: 2;
}

.leaflet-zoom-box {
  z-index: 8;
}

.leaflet-control {
  z-index: 7;
}

.leaflet-top,
.leaflet-bottom {
  z-index: 9;
}

.leaflet-control-locate a {
  width: 40px;
  height: 40px;
  font-size: 1.7rem;
  line-height: 1.7rem;
}

.marker-icon,
.marker-icon:focus {
  background-color: #ffffff;
  border: 1px solid #3388ff;
  border-radius: 50%;
  margin: -8px 0 0 -8px !important;
  width: 14px !important;
  height: 14px !important;
  outline: 0;
  transition: opacity ease 0.3s;
}

.marker-icon-middle {
  opacity: 0.7;
  margin: -6px 0 0 -6px !important;
  width: 10px !important;
  height: 10px !important;
}

.leaflet-vertex-icon.marker-snapped,
.leaflet-drawing-icon.marker-snapped {
  opacity: 1 !important;
}

/* Marker clusters */

.marker-cluster-small {
  background-color: rgba(12, 166, 158, 0.4);
}

.marker-cluster-small div {
  background-color: rgba(12, 166, 158, 0.8);
}

.marker-cluster-medium {
  background-color: rgba(12, 166, 158, 0.4);
}

.marker-cluster-medium div {
  background-color: rgba(12, 166, 158, 0.8);
}

.marker-cluster-large {
  background-color: rgba(12, 166, 158, 0.4);
}

.marker-cluster-large div {
  background-color: rgba(12, 166, 158, 0.8);
}

.marker-cluster {
  background-clip: padding-box;
  border-radius: 20px;
}

.marker-cluster div {
  width: 30px;
  height: 30px;
  margin-left: 5px;
  margin-top: 5px;
  text-align: center;
  border-radius: 15px;
  font-family: noto-sans-display, aktiv-grotesk, sans-serif;
  font-size: 1rem;
}

.marker-cluster span {
  line-height: 30px;
  color: #fff;
}

.leaflet-cluster-anim .leaflet-marker-icon,
.leaflet-cluster-anim .leaflet-marker-shadow {
  -webkit-transition:
    -webkit-transform 0.3s ease-out,
    opacity 0.3s ease-in;
  -moz-transition:
    -moz-transform 0.3s ease-out,
    opacity 0.3s ease-in;
  -o-transition:
    -o-transform 0.3s ease-out,
    opacity 0.3s ease-in;
  transition:
    transform 0.3s ease-out,
    opacity 0.3s ease-in;
}

.measurement-marker {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  padding: 5px;
  white-space: nowrap;
}

.measurement-marker-area {
  background-color: rgb(241, 101, 83, 0.8);
  border-radius: 4px;
  padding: 5px;
  white-space: nowrap;
  color: white;
}

.leaflet-cluster-spider-leg {
  /* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */
  -webkit-transition:
    -webkit-stroke-dashoffset 0.3s ease-out,
    -webkit-stroke-opacity 0.3s ease-in;
  -moz-transition:
    -moz-stroke-dashoffset 0.3s ease-out,
    -moz-stroke-opacity 0.3s ease-in;
  -o-transition:
    -o-stroke-dashoffset 0.3s ease-out,
    -o-stroke-opacity 0.3s ease-in;
  transition:
    stroke-dashoffset 0.3s ease-out,
    stroke-opacity 0.3s ease-in;
}

.best-faisa-tooltip {
  color: white;
  border: 2px;
  border-radius: 2px;
  padding: 2px;
  box-shadow: none;
  background-color: #a4beffb0;
  text-align: center;
  font-size: 0.8rem;
}

.best-faisa-quotes-tooltip {
  color: white;
  border: 2px;
  border-radius: 2px;
  padding: 2px;
  box-shadow: none;
  background-color: #a4beffb0;
  text-align: center;
  font-size: 0.8rem;
}

/* ------- ruler ----------- */
/* from https://github.com/gokertanrisever/leaflet-ruler/blob/master/src/leaflet-ruler.css */

.leaflet-ruler {
  height: 40px;
  width: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  /* <div>Icons made by <a href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div> */
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30px;
}

.leaflet-ruler:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  /* <div>Icons made by <a href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div> */
  background-color: #7fcbb4;
}

.leaflet-ruler-clicked {
  height: 40px;
  width: 40px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 30px;
  background-color: #16a29a !important;
  /* border-color: chartreuse !important; */
}

.leaflet-bar {
  background-color: #ffffff;
  border-radius: 8px;
}

.leaflet-control {
  cursor: pointer;
}

/* RULER */
.leaflet-left .leaflet-control {
  margin-bottom: 8px;
}

.result-tooltip {
  background-color: white;
  border: none;
  font-size: smaller;
}

.create-project-popup .leaflet-popup-tip-container {
  display: none;
}

.moving-tooltip {
  background-color: rgba(255, 255, 255, 0.7);
  background-clip: padding-box;
  opacity: 0.5;
  border: none;
  font-size: smaller;
}

.plus-length {
  padding-left: 45px;
}

/** ZOOM **/
.leaflet-touch .leaflet-control-zoom-in,
.leaflet-touch .leaflet-control-zoom-out {
  font-family: noto-sans-display, aktiv-grotesk, sans-serif;
  font-size: 1.4rem;
  color: rgb(128, 128, 128);
  font-weight: 400;
}

.leaflet-touch .leaflet-bar {
  border: 1px solid hsl(0, 0%, 90%);
  margin-left: 16px;
  box-shadow: rgba(0, 0, 0, 0.2);
}

.leaflet-touch .leaflet-bar a {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.leaflet-bar a {
  color: rgb(128, 128, 128);
}

.leaflet-bar a:hover {
  color: white;
  background-color: #7fcbb4;
}

.leaflet-touch .leaflet-bar a:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.leaflet-touch .leaflet-bar a:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.leaflet-popup-toolbar li {
  margin-bottom: 0;
}

body .leaflet-popup-toolbar > li > .leaflet-toolbar-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.leaflet-toolbar-0 > li > .leaflet-toolbar-icon.selected-mode:hover {
  background-color: #959595;
}

.leaflet-toolbar-icon > svg {
  width: 65%;
  height: 65%;
}

.project-prescriptions-img {
  mix-blend-mode: multiply;
}

.neighbour-parcel {
  cursor: copy;
}
/** SCALE **/

.leaflet-left .leaflet-control-scale {
  margin-bottom: 27px;
  margin-left: 11px;
}

@media print {
  .leaflet-control-scale {
    margin-bottom: 30px !important;
  }
}

/** LINKS **/

@media print {
  .leaflet-container a {
    display: none !important;
  }
}

/*
* Once isRedesignAvailable is merged these styles should be applied as main ones
*/

.redesign-available .leaflet-bottom.leaflet-left {
  display: flex;
  right: 116px;
  bottom: 70px;
  column-gap: 10px;
  left: unset;
  flex-direction: row-reverse;
  align-items: center;
  width: calc(100% - 116px);
}

.redesign-available .leaflet-control-zoom {
  display: flex;
  align-items: center;
  margin: 0;
  background-color: transparent;
  border: none;
}

.redesign-available .leaflet-ruler {
  margin: 0;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  border: 1.5px solid #b5bdd3;
  transition-property: color, background-color, border-color,
    text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.redesign-available .leaflet-control-zoom-in {
  border: 1.5px solid #b5bdd3 !important;
  border-right-width: 1px !important;
  border-radius: 0 !important;
  border-top-left-radius: 100% !important;
  border-bottom-left-radius: 100% !important;
  line-height: 37px !important;
}

.redesign-available .leaflet-control-zoom-out {
  border: 1.5px solid #b5bdd3 !important;
  border-left-width: 0.5px !important;
  border-radius: 0 !important;
  border-top-right-radius: 100% !important;
  border-bottom-right-radius: 100% !important;
  line-height: 33px !important;
}

.redesign-available .leaflet-ruler-clicked,
.redesign-available .leaflet-ruler:hover,
.redesign-available .leaflet-control-zoom .leaflet-control-zoom-in:hover,
.redesign-available .leaflet-control-zoom .leaflet-control-zoom-out:hover {
  background-color: rgb(0, 205, 131) !important;
  border-color: rgb(0, 205, 131) !important;
}

.redesign-available .leaflet-control-scale {
  margin: 0;
  margin-right: 20px;
  align-self: flex-end;
}

.redesign-available .leaflet-control-scale + div {
  position: relative !important;
  margin-right: auto !important;
  margin-bottom: -80px !important;
}

.redesign-available .leaflet-control-zoom-out,
.redesign-available
  .leaflet-control-zoom-out:hover
  .redesign-available
  .leaflet-control-zoom-in,
.redesign-available .leaflet-control-zoom-in:hover {
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-family: 'Sora';
  line-height: 2px !important;
}
`, "",{"version":3,"sources":["webpack://./css/leaflet.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yDAAyD;EACzD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yDAAyD;EACzD,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,oBAAoB;;AAEpB;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yDAAyD;EACzD,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE;;wBAEsB;EACtB;;wBAEsB;EACtB;;wBAEsB;EACtB;;wBAEsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2HAA2H;EAC3H;;uCAEqC;EACrC;;oCAEkC;EAClC;;kCAEgC;EAChC;;+BAE6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B,4FAA4F;;AAE5F;EACE,YAAY;EACZ,WAAW;EACX,yDAA2D;EAC3D,0SAA0S;EAC1S,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yDAAiE;EACjE,0SAA0S;EAC1S,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,2BAA2B;EAC3B,yDAAiE;EACjE,qBAAqB;EACrB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,WAAW;AACX;;EAEE,yDAAyD;EACzD,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;AACA,YAAY;;AAEZ;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,YAAY;;AAEZ;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;;CAEC;;AAED;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B;uCACqC;EACrC,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,uCAAuC;EACvC,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,2BAA2B;EAC3B,wCAAwC;EACxC,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;;;;EAIE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;;;;;;EAME,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":[".leaflet-control.info-box {\n  margin-bottom: 60x;\n  padding: 8px 16px;\n  font-family: noto-sans-display, aktiv-grotesk, sans-serif;\n  font-weight: 300;\n  font-size: 1rem;\n  background: white;\n  border: 1px solid hsl(0, 0%, 90%);\n  border-radius: 4px;\n  color: #031016;\n  max-width: 235px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.leaflet-control.info-box h5 {\n  margin: 5px 0 5px;\n  color: #031016;\n}\n\n.leaflet-control.info-box ul {\n  padding-left: 16px;\n  margin-top: 4px;\n}\n\n.leaflet-popup-content {\n  font-family: noto-sans-display, aktiv-grotesk, sans-serif;\n  margin: 0;\n  width: 325px;\n}\n\n.leaflet-popup-content h4 {\n  margin: 0 0 5px;\n  color: #031016;\n}\n\n.leaflet-popup-content-wrapper {\n  text-align: left;\n  border-radius: 8px;\n  padding: 0;\n}\n\n.leaflet-container a.leaflet-popup-close-button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 16px 24px 0 0;\n  border: none;\n  text-align: center;\n  width: 18px;\n  height: 14px;\n  font-family: noto-sans-display, aktiv-grotesk, sans-serif;\n  font-size: 1.4rem;\n  color: #c3c3c3;\n  text-decoration: none;\n  font-weight: 300;\n  background: transparent;\n}\n\n.leaflet-pane {\n  z-index: 4;\n}\n\n.leaflet-tile-pane {\n  z-index: 2;\n}\n\n.leaflet-overlay-pane {\n  z-index: 4;\n}\n\n.leaflet-shadow-pane {\n  z-index: 5;\n}\n\n.leaflet-marker-pane {\n  z-index: 6;\n}\n\n.leaflet-popup-pane {\n  z-index: 7;\n}\n\n.leaflet-tooltip-pane {\n  z-index: 8;\n}\n\n.leaflet-map-pane canvas {\n  z-index: 1;\n}\n\n.leaflet-map-pane svg {\n  z-index: 2;\n}\n\n.leaflet-zoom-box {\n  z-index: 8;\n}\n\n.leaflet-control {\n  z-index: 7;\n}\n\n.leaflet-top,\n.leaflet-bottom {\n  z-index: 9;\n}\n\n.leaflet-control-locate a {\n  width: 40px;\n  height: 40px;\n  font-size: 1.7rem;\n  line-height: 1.7rem;\n}\n\n.marker-icon,\n.marker-icon:focus {\n  background-color: #ffffff;\n  border: 1px solid #3388ff;\n  border-radius: 50%;\n  margin: -8px 0 0 -8px !important;\n  width: 14px !important;\n  height: 14px !important;\n  outline: 0;\n  transition: opacity ease 0.3s;\n}\n\n.marker-icon-middle {\n  opacity: 0.7;\n  margin: -6px 0 0 -6px !important;\n  width: 10px !important;\n  height: 10px !important;\n}\n\n.leaflet-vertex-icon.marker-snapped,\n.leaflet-drawing-icon.marker-snapped {\n  opacity: 1 !important;\n}\n\n/* Marker clusters */\n\n.marker-cluster-small {\n  background-color: rgba(12, 166, 158, 0.4);\n}\n\n.marker-cluster-small div {\n  background-color: rgba(12, 166, 158, 0.8);\n}\n\n.marker-cluster-medium {\n  background-color: rgba(12, 166, 158, 0.4);\n}\n\n.marker-cluster-medium div {\n  background-color: rgba(12, 166, 158, 0.8);\n}\n\n.marker-cluster-large {\n  background-color: rgba(12, 166, 158, 0.4);\n}\n\n.marker-cluster-large div {\n  background-color: rgba(12, 166, 158, 0.8);\n}\n\n.marker-cluster {\n  background-clip: padding-box;\n  border-radius: 20px;\n}\n\n.marker-cluster div {\n  width: 30px;\n  height: 30px;\n  margin-left: 5px;\n  margin-top: 5px;\n  text-align: center;\n  border-radius: 15px;\n  font-family: noto-sans-display, aktiv-grotesk, sans-serif;\n  font-size: 1rem;\n}\n\n.marker-cluster span {\n  line-height: 30px;\n  color: #fff;\n}\n\n.leaflet-cluster-anim .leaflet-marker-icon,\n.leaflet-cluster-anim .leaflet-marker-shadow {\n  -webkit-transition:\n    -webkit-transform 0.3s ease-out,\n    opacity 0.3s ease-in;\n  -moz-transition:\n    -moz-transform 0.3s ease-out,\n    opacity 0.3s ease-in;\n  -o-transition:\n    -o-transform 0.3s ease-out,\n    opacity 0.3s ease-in;\n  transition:\n    transform 0.3s ease-out,\n    opacity 0.3s ease-in;\n}\n\n.measurement-marker {\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 4px;\n  padding: 5px;\n  white-space: nowrap;\n}\n\n.measurement-marker-area {\n  background-color: rgb(241, 101, 83, 0.8);\n  border-radius: 4px;\n  padding: 5px;\n  white-space: nowrap;\n  color: white;\n}\n\n.leaflet-cluster-spider-leg {\n  /* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */\n  -webkit-transition:\n    -webkit-stroke-dashoffset 0.3s ease-out,\n    -webkit-stroke-opacity 0.3s ease-in;\n  -moz-transition:\n    -moz-stroke-dashoffset 0.3s ease-out,\n    -moz-stroke-opacity 0.3s ease-in;\n  -o-transition:\n    -o-stroke-dashoffset 0.3s ease-out,\n    -o-stroke-opacity 0.3s ease-in;\n  transition:\n    stroke-dashoffset 0.3s ease-out,\n    stroke-opacity 0.3s ease-in;\n}\n\n.best-faisa-tooltip {\n  color: white;\n  border: 2px;\n  border-radius: 2px;\n  padding: 2px;\n  box-shadow: none;\n  background-color: #a4beffb0;\n  text-align: center;\n  font-size: 0.8rem;\n}\n\n.best-faisa-quotes-tooltip {\n  color: white;\n  border: 2px;\n  border-radius: 2px;\n  padding: 2px;\n  box-shadow: none;\n  background-color: #a4beffb0;\n  text-align: center;\n  font-size: 0.8rem;\n}\n\n/* ------- ruler ----------- */\n/* from https://github.com/gokertanrisever/leaflet-ruler/blob/master/src/leaflet-ruler.css */\n\n.leaflet-ruler {\n  height: 40px;\n  width: 40px;\n  background-image: url('../assets/images/leaflet/ruler.png');\n  /* <div>Icons made by <a href=\"http://www.freepik.com\" title=\"Freepik\">Freepik</a> from <a href=\"http://www.flaticon.com\" title=\"Flaticon\">www.flaticon.com</a> is licensed by <a href=\"http://creativecommons.org/licenses/by/3.0/\" title=\"Creative Commons BY 3.0\" target=\"_blank\">CC 3.0 BY</a></div> */\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 30px;\n}\n\n.leaflet-ruler:hover {\n  background-image: url('../assets/images/leaflet/ruler-hover.png');\n  /* <div>Icons made by <a href=\"http://www.freepik.com\" title=\"Freepik\">Freepik</a> from <a href=\"http://www.flaticon.com\" title=\"Flaticon\">www.flaticon.com</a> is licensed by <a href=\"http://creativecommons.org/licenses/by/3.0/\" title=\"Creative Commons BY 3.0\" target=\"_blank\">CC 3.0 BY</a></div> */\n  background-color: #7fcbb4;\n}\n\n.leaflet-ruler-clicked {\n  height: 40px;\n  width: 40px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url('../assets/images/leaflet/ruler-hover.png');\n  background-size: 30px;\n  background-color: #16a29a !important;\n  /* border-color: chartreuse !important; */\n}\n\n.leaflet-bar {\n  background-color: #ffffff;\n  border-radius: 8px;\n}\n\n.leaflet-control {\n  cursor: pointer;\n}\n\n/* RULER */\n.leaflet-left .leaflet-control {\n  margin-bottom: 8px;\n}\n\n.result-tooltip {\n  background-color: white;\n  border: none;\n  font-size: smaller;\n}\n\n.create-project-popup .leaflet-popup-tip-container {\n  display: none;\n}\n\n.moving-tooltip {\n  background-color: rgba(255, 255, 255, 0.7);\n  background-clip: padding-box;\n  opacity: 0.5;\n  border: none;\n  font-size: smaller;\n}\n\n.plus-length {\n  padding-left: 45px;\n}\n\n/** ZOOM **/\n.leaflet-touch .leaflet-control-zoom-in,\n.leaflet-touch .leaflet-control-zoom-out {\n  font-family: noto-sans-display, aktiv-grotesk, sans-serif;\n  font-size: 1.4rem;\n  color: rgb(128, 128, 128);\n  font-weight: 400;\n}\n\n.leaflet-touch .leaflet-bar {\n  border: 1px solid hsl(0, 0%, 90%);\n  margin-left: 16px;\n  box-shadow: rgba(0, 0, 0, 0.2);\n}\n\n.leaflet-touch .leaflet-bar a {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n}\n\n.leaflet-bar a {\n  color: rgb(128, 128, 128);\n}\n\n.leaflet-bar a:hover {\n  color: white;\n  background-color: #7fcbb4;\n}\n\n.leaflet-touch .leaflet-bar a:first-child {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.leaflet-touch .leaflet-bar a:last-child {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.leaflet-popup-toolbar li {\n  margin-bottom: 0;\n}\n\nbody .leaflet-popup-toolbar > li > .leaflet-toolbar-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.leaflet-toolbar-0 > li > .leaflet-toolbar-icon.selected-mode:hover {\n  background-color: #959595;\n}\n\n.leaflet-toolbar-icon > svg {\n  width: 65%;\n  height: 65%;\n}\n\n.project-prescriptions-img {\n  mix-blend-mode: multiply;\n}\n\n.neighbour-parcel {\n  cursor: copy;\n}\n/** SCALE **/\n\n.leaflet-left .leaflet-control-scale {\n  margin-bottom: 27px;\n  margin-left: 11px;\n}\n\n@media print {\n  .leaflet-control-scale {\n    margin-bottom: 30px !important;\n  }\n}\n\n/** LINKS **/\n\n@media print {\n  .leaflet-container a {\n    display: none !important;\n  }\n}\n\n/*\n* Once isRedesignAvailable is merged these styles should be applied as main ones\n*/\n\n.redesign-available .leaflet-bottom.leaflet-left {\n  display: flex;\n  right: 116px;\n  bottom: 70px;\n  column-gap: 10px;\n  left: unset;\n  flex-direction: row-reverse;\n  align-items: center;\n  width: calc(100% - 116px);\n}\n\n.redesign-available .leaflet-control-zoom {\n  display: flex;\n  align-items: center;\n  margin: 0;\n  background-color: transparent;\n  border: none;\n}\n\n.redesign-available .leaflet-ruler {\n  margin: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  border: 1.5px solid #b5bdd3;\n  transition-property: color, background-color, border-color,\n    text-decoration-color, fill, stroke;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.redesign-available .leaflet-control-zoom-in {\n  border: 1.5px solid #b5bdd3 !important;\n  border-right-width: 1px !important;\n  border-radius: 0 !important;\n  border-top-left-radius: 100% !important;\n  border-bottom-left-radius: 100% !important;\n  line-height: 37px !important;\n}\n\n.redesign-available .leaflet-control-zoom-out {\n  border: 1.5px solid #b5bdd3 !important;\n  border-left-width: 0.5px !important;\n  border-radius: 0 !important;\n  border-top-right-radius: 100% !important;\n  border-bottom-right-radius: 100% !important;\n  line-height: 33px !important;\n}\n\n.redesign-available .leaflet-ruler-clicked,\n.redesign-available .leaflet-ruler:hover,\n.redesign-available .leaflet-control-zoom .leaflet-control-zoom-in:hover,\n.redesign-available .leaflet-control-zoom .leaflet-control-zoom-out:hover {\n  background-color: rgb(0, 205, 131) !important;\n  border-color: rgb(0, 205, 131) !important;\n}\n\n.redesign-available .leaflet-control-scale {\n  margin: 0;\n  margin-right: 20px;\n  align-self: flex-end;\n}\n\n.redesign-available .leaflet-control-scale + div {\n  position: relative !important;\n  margin-right: auto !important;\n  margin-bottom: -80px !important;\n}\n\n.redesign-available .leaflet-control-zoom-out,\n.redesign-available\n  .leaflet-control-zoom-out:hover\n  .redesign-available\n  .leaflet-control-zoom-in,\n.redesign-available .leaflet-control-zoom-in:hover {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  font-family: 'Sora';\n  line-height: 2px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
